import { useState } from 'react';
import { SlideMenu } from '../../../../common/components/slideMenu/SlideMenu';
import { KWELLO_ICON, KwelloSvgIcon } from '../../../../common/components/icon/KwelloSvgIcon';
import { MobileMenuContent } from './MobileMenuContent';
import ClickableDiv from 'common/components/clickableDiv/ClickableDiv';

export const MobileSideNav = () => {
  const [flyoutOpen, setFlyoutOpen] = useState<boolean>(false);
  return (
    <div className="mobile-header-container">
      <ClickableDiv onClick={() => setFlyoutOpen(!flyoutOpen)} className="hamburger">
        <KwelloSvgIcon icon={KWELLO_ICON.HAMBURGER_ICON} />
      </ClickableDiv>
      <SlideMenu
        showMenu={flyoutOpen}
        setShowMenu={setFlyoutOpen}
        width={'90vw'}
        height={'100vh'}
        slideDirection="left"
        hideBorder={true}
        className={'mobile-flyout-menu'}
      >
        <MobileMenuContent showMenu={flyoutOpen} closeMenu={() => setFlyoutOpen(!flyoutOpen)} />
      </SlideMenu>
    </div>
  );
};
